/* Shopify-native GET search. No catalog, tracking or availability assumptions. */
if (!customElements.get('vexon-finder')) {
  customElements.define('vexon-finder', class VexonFinder extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = this.querySelector('form');
      this.family = this.querySelector('[data-finder-family]');
      this.model = this.querySelector('[data-finder-model]');
      this.category = this.querySelector('[data-finder-category]');
      this.query = this.querySelector('[data-finder-query]');
      this.status = this.querySelector('[data-finder-status]');
      if (!this.form || !this.family || !this.model || !this.category || !this.query) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.modelOptions = Array.from(this.model.querySelectorAll('optgroup')).map(group => group.cloneNode(true));
      this.categoryOptions = Array.from(this.category.options).map(option => option.cloneNode(true));
      this.query.disabled = false;
      this.model.removeAttribute('name');
      this.dataset.enhanced = 'true';
      this.querySelectorAll('[data-finder-enhanced]').forEach(field => { field.hidden = false; });
      this.family.disabled = false;
      this.category.disabled = false;
      this.family.addEventListener('change', () => this.filterModels(), options);
      this.model.addEventListener('change', () => this.filterCategories(), options);
      this.category.addEventListener('change', () => this.updateQuery(), options);
      this.form.addEventListener('submit', () => this.updateQuery(), options);
      this.filterModels();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      if (this.model && this.modelOptions) {
        this.model.replaceChildren(new Option('Modelini seç', ''), ...this.modelOptions.map(group => group.cloneNode(true)));
        this.model.name = 'q';
      }
      if (this.category && this.categoryOptions) this.category.replaceChildren(...this.categoryOptions.map(option => option.cloneNode(true)));
      if (this.query) this.query.disabled = true;
      delete this.dataset.enhanced;
    }

    filterModels() {
      const previousModel = this.model.value;
      const family = this.family.value;
      const groups = this.modelOptions.filter(group => !family || group.dataset.family === family);
      this.model.replaceChildren(new Option('Modelini seç', ''), ...groups.map(group => group.cloneNode(true)));
      if (Array.from(this.model.options).some(option => option.value === previousModel)) this.model.value = previousModel;

      if (this.status) this.status.textContent = `${this.family.selectedOptions[0].textContent}: ${this.model.options.length - 1} model seçeneği.`;
      this.filterCategories();
    }

    filterCategories() {
      const previousCategory = this.category.value;
      const family = this.model.selectedOptions[0]?.dataset.family || this.family.value;
      const categories = this.categoryOptions.filter(option => !family || !option.dataset.families || option.dataset.families.split(' ').includes(family));
      this.category.replaceChildren(...categories.map(option => option.cloneNode(true)));
      const retained = Array.from(this.category.options).some(option => option.value === previousCategory);
      if (retained) this.category.value = previousCategory;
      else if (previousCategory && this.status) this.status.textContent = 'Cihazına uygun kategoriler güncellendi. Tüm aksesuarlar seçildi.';
      this.updateQuery();
    }

    updateQuery() {
      const model = this.model.value;
      const category = this.category.value;
      this.query.value = model ? `${model}${category ? ` AND ${category}` : ''}` : '';
    }
  });
}
